import { gql } from '@apollo/client';
import BaseService from './baseService';
import ComboServices from 'src/constants/comboServices';

class ServicesService extends BaseService {
  constructor(uri) {
    super(uri);
    this.serviceGql = `
      serviceId
      serviceName
      serviceKey
    `;
  }

  getServices = () =>
    new Promise((resolve, reject) => {
      const SERVICES = gql`
      query {
        services{
            ${this.serviceGql}
        }
      }
    `;

      this.client
        .query({
          fetchPolicy: 'no-cache',
          query: SERVICES,
        })
        .then(result => {
          if (result.data.services) {
            resolve(result.data.services.concat(ComboServices));
          } else {
            reject(result.data.error);
          }
        })
        .catch(error => {
          console.log('error', error);
          reject(error);
        });
    });
}

const servicesService = new ServicesService(
  `${process.env.REACT_APP_DISPATCH_QORE_API}/graphql`
);

export default servicesService;
